import React,{ Component, useState }  from 'react';
import { Button, Checkbox, Col, Form, Input, Radio, Row, Table, Tabs } from 'antd';
import type { TableProps, TabsProps } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import type { CheckboxProps } from 'antd';
import list from 'antd/es/list';

const onChange = (key: string) => {
  console.log(key);
};
const CheckboxGroup = Checkbox.Group;


const { Column } = Table;
const SDGsOption = ['GOAL 1: No Poverty',
                'GOAL 2: Zero Hunger',
                'GOAL 3: Good Health and Well-being',
                'GOAL 4: Quality Education',
                'GOAL 5: Gender Equality',
                'GOAL 6: Clean Water and Sanitation',
                'GOAL 7: Affordable and Clean Energy',
                'GOAL 8: Decent Work and Economic Growth',
                'GOAL 9: Industry, Innovation and Infrastructure',
                'GOAL 10: Reduced Inequality',
                'GOAL 11: Sustainable Cities and Communities',
                'GOAL 12: Responsible Consumption and Production',
                'GOAL 13: Climate Action',
                'GOAL 14: Life Below Water',
                'GOAL 15: Life on Land',
                'GOAL 16: Peace and Justice Strong Institutions',
                'GOAL 17: Strengthening global partnerships']


export function BudgetRequestForm(){
  const [checkedList, setCheckedList] = useState<string[]>();
  const [activeKey, setActiveKey] = React.useState('1')
  const onKeyChange = (key: React.SetStateAction<string>) => setActiveKey(key)

  const CheckSDGsonChange = (list: string[]) => {
    setCheckedList(list);
  };
  return (
    <Form name="Budget_req"
    >
      <Tabs className='card-tabs'>

        {/* ส่วนที่ 1 */}
        <Tabs.TabPane tab="ส่วนที่ 1" key={activeKey} >
          <h1 className="text-3xl font-semibold ">แบบฟอร์มเสนอโครงการงานวิจัยและนวัตกรรม</h1>
          <p>เพื่อขอรับเงินทุนสนับสนุนงานวิจัยและนวัตกรรมจากมหาวิทยาลัยวงษ์ชวลิตกุล</p>
          <br/>
          <hr/>
          <br/>
          <h2 className="text-3xL font-bold ">ส่วนที่ 1 ข้อมูลงานวิจัย</h2>
          <br/>

          <Row gutter={[8, 24]}>
          <Col span={24}>
          <Form.Item name={['project_name_th']} label='ชื่อโครงการวิจัย' layout="vertical">
          <Input placeholder="ชื่อโครงการภาษาไทย" />
          </Form.Item>
          <br/>
          </Col>
          </Row>
          
          <Row gutter={[8, 24]}>
          <Col span={24}>
          <Form.Item name={['project_name_en']} layout="vertical">
          <Input placeholder="ชื่อโครงการภาษาอังกฤษ" />
          </Form.Item>
          <br/>
          </Col>
          </Row>


          <Row gutter={[8, 92]}>
          <Col span={24}>
          <Form.Item name={['project_sdgs']} label='งานวิจัยมีความสอดคล้องกับ The 17 sustainable development goals (SDGs) ใด (เลือกได้มากกว่า 1 ข้อ)' layout="vertical">
          <CheckboxGroup options={SDGsOption} value={checkedList} onChange={CheckSDGsonChange} />
          </Form.Item>
          <br/>
          <br/>
          <br/>
          <br/>
          </Col>
          </Row>

          <Row gutter={[8, 8]}>
          <Col span={24}>
          <Form.Item name={['project_expectation']} label='การตอบสนองต่อความต้องการของประเทศและชุมชนพื้นที่' layout="vertical">
          <Radio.Group>
              <Radio value="ตอบสนองต่อยุทธศาสตร์ชาติ"> ตอบสนองต่อยุทธศาสตร์ชาติ </Radio>
              <Radio value="ตอบสนองต่อยุทธศาสตร์ของมหาวิทยาลัยวงษ์ชวลิตกุล"> ตอบสนองต่อยุทธศาสตร์ของมหาวิทยาลัยวงษ์ชวลิตกุล </Radio>
              <Radio value="ตอบสนองต่อความต้องการของชุมชนพื้นที่"> ตอบสนองต่อความต้องการของชุมชนพื้นที่ </Radio>
              <Radio value="ตอบสนองต่อการเรียนรู้ตลอดชีวิต / สังคมผู้สูงอายุ"> ตอบสนองต่อการเรียนรู้ตลอดชีวิต / สังคมผู้สูงอายุ </Radio>
            </Radio.Group>
          </Form.Item> 
          </Col>
          </Row>
          <br/>
          <hr/>
          <br/>
          <Form.Item name={['project_research_field']} label='สาขาวิชาที่ทำการวิจัย ( จำแนกตาม OECD )' layout="vertical">
          <Input />
          </Form.Item>
        </Tabs.TabPane>

        {/*ส่วนที่ 2 */}
        <Tabs.TabPane tab="ส่วนที่ 2" key='2'>
        <h2 className="text-2xL font-bold ">ส่วนที่ 2 ข้อมูลบุคลากรที่เกี่ยวข้องกับงานวิจัย</h2>
         <br/> 
          <Form.Item name={['project_name_th']} label='ชื่อผู้เชี่ยวชาญ / ผู้ทรงคุณวุฒิ / ที่ปรึกษา' layout="vertical">
          <Input />
          </Form.Item>
          <br/>
          <Form.Item name={['project_name_th']} label='ตำแหน่งทางวิชาการ' layout="vertical">
          <Input />
          </Form.Item>
          <br/>
          <Form.Item name={['project_name_th']} label='หน่วยงานที่สังกัด' layout="vertical">
          <Input />
          </Form.Item>
          <br/>
          <Form.Item name={['project_name_th']} label='ประสบการณ์ในการวิจัย' layout="vertical">
          <Input />
          </Form.Item>
          <br/>
          <h4 className="text-2xL font-bold ">คณะผู้ดำเนินงานวิจัยสัดส่วนงานวิจัย</h4>
          <h5>ประวัติหัวหน้าโครงการวิจัย / สัดส่วนงานวิจัย</h5>
          <Form.Item name={['project_name_th']} label='ชื่อ-สกุล' layout="vertical">
          <Input placeholder='ภาษาไทย'/>
          </Form.Item>
          <br/>
          <Form.Item name={['project_name_th']} layout="vertical">
          <Input placeholder='ภาษาอังกฤษ'/>
          </Form.Item>
          <br/>
          <p>วุฒิการศึกษา</p>
          <form>
          <Table
              footer={() => {
            

                return (
                  <Form.Item>
                    <Column
                    dataIndex={"Edu_level"}
                    title={"ระดับปริญญา"}
                    ></Column>
                  </Form.Item>
                );
              }}
          />
          </form>
        </Tabs.TabPane>
        
        {/*ส่วนที่ 3 */}
        <Tabs.TabPane tab="ส่วนที่ 3" key="3">
        <h2 className="text-2xL font-bold ">ส่วนที่ 3 รายละเอียดโครงการงานวิจัย</h2>
        <br/>
        <Form.Item name='f' label="ความสำคัญ / เหตุผล / ปัญหาที่สำคัญของงานวิจัย / นิยาม" layout="vertical">
        <Input/>
        </Form.Item>
        <br/>
        <Form.Item name='f' label="วัตถุประสงค์ของงานวิจัย" layout="vertical">
        <Input/>
        </Form.Item>
        <br/>
        <Form.Item name='f' label="ประโยชน์ที่คาดว่าจะได้รับ" layout="vertical">
        <Input/>
        </Form.Item>
        <br/>
        <Form.Item name='f' label="การทบทวนวรรณกรรมและผลงานวิจัยที่เกียวข้อง" layout="vertical">
        <Input/>
        </Form.Item>
        <br/>
        <Form.Item name='f' label="กรอบแนวคิดในการวิจัย" layout="vertical">
        <Input/>
        </Form.Item>
        <br/>
        <Form.Item name='f' label="ระเบียบวิธีวิจัย (รูปแบบการวิจัย/ตัวแปร/ประชากรและกลุ่มตัวอย่าง/เครื่องมือการวิจัย/ขั้นตอนการวิจัย/สถิติและการวิเคราะห์ข้อมูล)" layout="vertical">
        <Input/>
        </Form.Item>
        <br/>
        <Form.Item name='f' label="ระยะเวลาทำการวิจัย" layout="vertical">
        <Input/>
        </Form.Item>
        <br/>
        <Form.Item name='f' label="แผนการดำเนินงานตลอดโครงการ (โปรดระบุขั้นตอนการวิจัยโดยละเอียด) ในกรณีที่เป็นโครงการร่วมกันให้ระบุการแบ่งส่วนงานและผู้รับผิดชอบ" layout="vertical">
        <Input/>
        </Form.Item>
        <br/>

        <h3 className="text-2xL">อุปกรณ์</h3>
        <Form.Item name='f' label="อุปกรณ์ที่จำเป็นในงานวิจัย" layout="vertical">
        <Input/>
        </Form.Item>
        <br/>
        <Form.Item name='f' label="อุปกรณ์ที่มีอยู่แล้ว" layout="vertical">
        <Input/>
        </Form.Item>
        <br/>
        </Tabs.TabPane>
          
        {/* ส่วนที่ 4 */}
        <Tabs.TabPane tab="ส่วนที่ 4" key="4">
        <h2 className="text-2xL font-bold ">ส่วนที่ 4 ผลลัพธ์และผลกระทบ</h2>
        <br/>
        <Form.Item name={"project_output"} label="ผลผลิตที่คาดว่าจะได้รับ (Output)">

        </Form.Item>
        <Form.Item name={"project_output"} label="ผลลัพธ์ที่คาดว่าจะเกิดขึ้น (Expected Outcomes) ">

        </Form.Item>
        <div>ผลกระทบ (Expected Impacts) ที่คาดว่าจะเกิดขึ้น</div>
        <Form.Item name='f' label="ด้านวิชาการ" layout="vertical">
        <Input/>
        </Form.Item>
        <br/>
        <Form.Item name='f' label="ด้านสังคม" layout="vertical">
        <Input/>
        </Form.Item>
        <br/>
        <Form.Item name='f' label="ด้านสาธารณะ" layout="vertical">
        <Input/>
        </Form.Item>
        <br/>
        <Form.Item name='f' label="ด้านชุมชนและพื้นที่" layout="vertical">
        <Input/>
        </Form.Item>
        <br/>
        <Form.Item name='f' label="ด้านสิ่งแวดล้อม" layout="vertical">
        <Input/>
        </Form.Item>
        <br/>
        <Form.Item name='f' label="ด้านโยบาย" layout="vertical">
        <Input/>
        </Form.Item>
        <br/>
        <Form.Item name='f' label="ด้านเศรษฐกิจ" layout="vertical">
        <Input/>
        </Form.Item>
        </Tabs.TabPane>

        {/* ส่วนที่ 5 */}
        <Tabs.TabPane tab="ส่วนที่ 5" key="5">
        <h2 className="text-2xL font-bold ">ส่วนที่ 5 งบประมาณและค่าใช้จ่าย</h2> 
        </Tabs.TabPane>
      </Tabs>

    </Form>
  )
}